import { CheckCircle2, Clock, Coffee, Factory } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface Props {
  totalCount: number;
  completedCount: number;
  draftCount: number;
  totalOutputUnits: number;
}

export function ProductionSummaryCards({
  totalCount,
  completedCount,
  draftCount,
  totalOutputUnits,
}: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground truncate">
            Total Batch Produksi
          </CardTitle>
          <Factory className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-muted-foreground shrink-0" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold">{totalCount}</div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Dokumen batch produksi barang jadi
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground truncate">
            Produksi Selesai
          </CardTitle>
          <CheckCircle2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-emerald-500 shrink-0" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-emerald-600 dark:text-emerald-400">
            {completedCount}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Batch selesai masuk ke stok toko
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground truncate">
            Menunggu / Draft
          </CardTitle>
          <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-amber-500 shrink-0" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-amber-600 dark:text-amber-400">
            {draftCount}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Draft batch dalam proses seduh / racik
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground truncate">
            Total Output
          </CardTitle>
          <Coffee className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-indigo-500 shrink-0" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-indigo-600 dark:text-indigo-400">
            {totalOutputUnits.toLocaleString("id-ID")}{" "}
            <span className="text-[10px] sm:text-xs font-normal text-muted-foreground">
              cup / porsi
            </span>
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Akumulasi barang jadi yang siap dijual
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
